import { restClient } from '@/Core'

import { toCollection, toNode } from '../Helpers/diskResponse'

import type { DiskNode } from '../Contracts/DiskNode'

/** Нещодавні — короткий перелік без сторінок: `GET /services/disk/recent`. */
export const LoadDiskRecentTask = async (): Promise<DiskNode[]> => {
    const response = (await restClient.get('/services/disk/recent', {}, { forceRefresh: true })) as unknown

    return toCollection(response, toNode).items
}
